import React from 'react'
import About from './components/About';
import Contact from './components/Contact';
import Experience from './components/Experience';
import Home from './components/Home';
import NavBar from './components/common/NavBar';
import SocialLinks from './components/SocialLinks';
import Aos from 'aos';
import "aos/dist/aos.css";
import Footer from './components/common/Footer';
import { GithubProvider } from './context/github/GithubContext';

import Share from './components/Share';
import Projects from './components/projects/Projects';


const App = () => {
  Aos.init({
    duration: 1500,
    offset: 150,
    once: true,
  });

  return (
    <GithubProvider>
      <div className='overflow-x-hidden'>
        <NavBar />
        <Home />
        <About />
        {/* <Portfolio /> */}
        <Projects />
        <Experience />
        <Contact />
        <Footer />

        <SocialLinks />
        <Share />
      </div>
    </GithubProvider>
  )
}

export default App;
